// extracted by mini-css-extract-plugin
module.exports = {"vUiHueLight":"#eee","vUiHue":"#ddd","vInk":"#131313","vBlue":"#107ef1","vStartEndBorderRadius":"0","wrapper":"styles__wrapper___8bQ9v"};